// @flow
import * as React from 'react';

import assertions from 'lib/assertions';
import Button from 'components/ButtonDeprecated';
import Columns2 from 'components/Columns2';
import Container from 'components/Container';
import CopyToClipboardField from 'components/CopyToClipboardField';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import Notice from 'components/Notice';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  credentials: ?{
    username: string,
    password: string,
  },
  onCredentialGeneration: (displayName: ?string) => void,
};

type State = {
  displayName: ?string,
};

class AdminNewAutoMessageSftpCredentialsForm extends React.Component<Props, State> {
  state = {
    displayName: undefined,
  };

  handleNameChange = (displayName: ?string) => {
    this.setState({ displayName });
  };

  renderGenerateCredentials = () => {
    const { displayName } = this.state;
    return (
      <Row>
        <Text
          align="left"
          element="div"
          className="AdminAutoMessageSftpCredentialsForm-credentials">
          <Text size="small" element="p">
            Click on the button to generate a username and password. For greater security, your
            password will only be shown once.
          </Text>
          <Button
            data-test="generate-credentials-button"
            onClick={() => this.props.onCredentialGeneration(displayName)}
            disabled={!displayName}>
            Generate credentials
          </Button>
        </Text>
      </Row>
    );
  };

  renderCredentials = (credentials: { username: string, password: string }) => {
    return (
      <Row>
        <Text
          align="left"
          element="div"
          className="AdminAutoMessageSftpCredentialsForm-credentials">
          <Row size="small">
            <Notice glyph="explanation" color="mascot" noShadow full>
              <Text size="xsmall">
                Record your credentials for your own records. For greater security, your password
                will not be shown again.
              </Text>
            </Notice>
          </Row>
          <Columns2 gutter="small">
            <CopyToClipboardField label="Username" value={credentials.username} theme="whiteout" />
            <CopyToClipboardField label="Password" value={credentials.password} theme="whiteout" />
          </Columns2>
        </Text>
      </Row>
    );
  };

  render() {
    const { credentials } = this.props;
    const { displayName } = this.state;

    const uploadUrl = 'sftp://sftp.remind.com';
    const port = '22';

    return (
      <Container full>
        <Row size="small">
          <FormElement
            data-test="credential-name-field"
            label="Credential name"
            onValidChange={e => this.handleNameChange(e.target.value)}
            onInvalidChange={() => this.handleNameChange(undefined)}
            subtext="The credential name is only visible to you and other administrators. Use it to help you differentiate between sets of credentials."
            validate={e => {
              assertions.notEmpty(e.target.value, 'Please enter a name');
            }}
            element={Input}
            elementProps={{
              defaultValue: displayName,
              placeholder: 'e.g. PowerSchool Attendance, MyLunchMoney Balance',
              disabled: Boolean(credentials),
            }}
          />
        </Row>
        <Row size="small">
          <Columns2 gutter="small">
            <CopyToClipboardField label="Upload URL" value={uploadUrl} />
            <CopyToClipboardField label="Port" value={port} />
          </Columns2>
        </Row>
        {credentials ? this.renderCredentials(credentials) : this.renderGenerateCredentials()}
      </Container>
    );
  }
}

export default AdminNewAutoMessageSftpCredentialsForm;
